import { render, staticRenderFns } from "./type_4.vue?vue&type=template&id=6bfb718d&scoped=true"
import script from "./type_4.vue?vue&type=script&lang=js"
export * from "./type_4.vue?vue&type=script&lang=js"
import style0 from "./type_4.vue?vue&type=style&index=0&id=6bfb718d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb718d",
  null
  
)

export default component.exports